import styled from '@emotion/styled';
import { COLORS } from '@ui-kit-ngs/theme';
const heightPartialCSS = ({ stretched, theme, }) => {
    if (stretched)
        return 'height: auto';
    return theme.device === 'desktop' ? '36px' : '48px';
};
const StyledCarouselContainer = styled.div `
  overflow: hidden;
  display: flex;
  background-color: ${({ theme, light }) => light
    ? COLORS.background000
    : theme.colors.backgrounds.primaryNavigation.background};
  ${heightPartialCSS}
`;
export default StyledCarouselContainer;
